import React from 'react';
import MaterialModal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import styled from 'styled-components/macro';
import { ReactComponent as CloseIcon } from 'assets/icons/close-black.svg';
import { Typography } from '@deeptrue-frontend/ui';

const Modal = styled(MaterialModal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  outline: none;
  background-color: #fff;
  position: relative;
  min-width: 30rem;
`;

const Content = styled.div<{ disablePadding?: boolean }>`
  outline: none;
  background-color: #fff;
  position: relative;
  padding: ${({ disablePadding }) =>
    disablePadding ? 0 : '0 1.5rem 1.5rem 1.5rem'};
  min-width: 30rem;
  max-height: 80vh;
  overflow: auto;
`;

const Close = styled(CloseIcon)`
  position: absolute;
  top: 1.25rem;
  right: 1rem;
  fill: black;
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #dedede;
  margin: 0 0 1rem 0;
`;

const Title = styled(Typography)`
  padding: 1rem 2rem;
`;

interface Props {
  children: any;
  open: boolean;
  onClose: () => void;
  title: string;
  disablePadding?: boolean;
}

const ModalWithTitle = ({
  children,
  open,
  onClose,
  title,
  disablePadding,
}: Props) => {
  return (
    <Modal open={open} onClose={onClose} disableEnforceFocus={true}>
      <Fade in={open}>
        <Container>
          <Close onClick={onClose} />
          <Title variant="h5">{title}</Title>
          <Separator />
          <Content disablePadding={disablePadding}>{children}</Content>
        </Container>
      </Fade>
    </Modal>
  );
};

export default ModalWithTitle;
